import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { MISSION_PAGE_MODES } from 'utils/constants'
import { RootState } from 'utils/interfaces'

interface EditingControlsInstructionsProps {
  forceRouteMode?: boolean
  forceDrawingMode?: boolean
}

const EditingControlsInstructions = ({ forceRouteMode, forceDrawingMode }: EditingControlsInstructionsProps = {}) => {
  const { t } = useTranslation()
  const isDrawingModeStore = useSelector(
    (state: RootState) =>
      state.mission.mode === MISSION_PAGE_MODES.DRAW_ROUTE || state.mission.mode === MISSION_PAGE_MODES.DRAW_ZONE
  )
  const isRouteModeStore = useSelector(
    (state: RootState) =>
      state.mission.mode === MISSION_PAGE_MODES.EDIT_ZONE_ROUTE || state.mission.mode === MISSION_PAGE_MODES.DRAW_ROUTE
  )

  const isDrawingMode = forceDrawingMode !== undefined ? forceDrawingMode : isDrawingModeStore
  const isRouteMode = forceRouteMode !== undefined ? forceRouteMode : isRouteModeStore

  return (
    <div
      className="text-12-400"
      style={{
        color: 'var(--text-secondary, #808080)',
        marginTop: '12px',
        marginBottom: '16px',
        flexShrink: 0,
        paddingLeft: '14px',
        paddingRight: '14px',
      }}
    >
      {isDrawingMode ? (
        <>
          <div style={{ marginBottom: '4px', fontWeight: 600 }}>1. Drawing Controls:</div>
          <ul
            style={{
              margin: 0,
              paddingLeft: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              marginBottom: '12px',
            }}
          >
            <li>
              <strong>Click:</strong> Add point
            </li>
            <li>
              <strong>Double Click</strong> or <strong>Click last point:</strong> Finish drawing
            </li>
          </ul>
          <div style={{ marginBottom: '4px', fontWeight: 600 }}>2. Editing Controls (After finishing):</div>
          <ul style={{ margin: 0, paddingLeft: '16px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <li>
              <strong>Click:</strong> Select point
            </li>
            <li>
              <strong>Shift + Click:</strong> Select several points
            </li>
            {isRouteMode && (
              <li>
                <strong>Ctrl / Cmd + Click</strong> (on map): Add point
              </li>
            )}
            <li>
              <strong>Alt / Option + Click:</strong> Delete point
            </li>
            <li>
              <strong>Ctrl / Cmd + Z:</strong> Undo
            </li>
            <li>
              <strong>Ctrl / Cmd + Shift + Z:</strong> Redo
            </li>
          </ul>
        </>
      ) : (
        <>
          <div style={{ marginBottom: '4px', fontWeight: 600 }}>Editing Controls:</div>
          <ul style={{ margin: 0, paddingLeft: '16px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <li>
              <strong>Click:</strong> Select point
            </li>
            <li>
              <strong>Shift + Click:</strong> Select several points
            </li>
            {isRouteMode && (
              <li>
                <strong>Ctrl / Cmd + Click</strong> (on map): Add point
              </li>
            )}
            <li>
              <strong>Alt / Option + Click:</strong> Delete point
            </li>
            <li>
              <strong>Ctrl / Cmd + Z:</strong> Undo
            </li>
            <li>
              <strong>Ctrl / Cmd + Shift + Z:</strong> Redo
            </li>
          </ul>
        </>
      )}
    </div>
  )
}

export default EditingControlsInstructions
